export default __webpack_public_path__ + "static/media/I.08a2be4f.svg";